export default {
  LIST_LOAD: 'ACCOUNTING_LOAD',
  NEWS_LIST_FETCHED: 'ACCOUNTING_NEWS_FETCHED',
  NEWS_LIST_LOAD: 'ACCOUNTING_NEWS_LOAD',
  NEWS_LIST_SET: 'ACCOUNTING_NEWS_SET',
};
